import { isInteger } from "lodash"
import Banner from "~/components/banner"
import Figure from "~/components/figure"
import { encode } from "~/components/svgEncode"

const layers = [
  "conv2d0",
  "conv2d1",
  "conv2d2",
  "mixed3a",
  "mixed3b",
  "mixed4a",
  "mixed4b",
  "mixed4c",
  "mixed4d",
  "mixed4e",
  "mixed5a",
  "mixed5b",
]

export default class Encoder extends Component {
  state = {
    text: "mixed3a:174",
    encoded: "",
  }

  onEncode = text => {
    if (text.indexOf(":") === -1) return
    let [layer, neuron] = text.split(":")

    if (layers.indexOf(layer) === -1) return

    const layerIndex = layers.indexOf(layer)

    if (!isInteger(+neuron)) return

    const type = 0
    const encoded = encode(type, layerIndex, +neuron)

    this.setState({ text, encoded })
  }

  render() {
    const { encoded, text } = this.state
    return (
      <React.Fragment>
        <Banner
          title="Encoder"
          subtitle="For custom figures"
          noFigure
          noAuthors
        />
        <Figure>
          <Surface>
            <input
              type="text"
              value={text}
              onChange={e => this.onEncode(e.target.value)}
              style={{ fontSize: 18, margin: "5px 20px" }}
            />
            <input
              type="text"
              value={encoded}
              style={{ fontSize: 18, margin: "5px 20px" }}
            />
          </Surface>
        </Figure>
      </React.Fragment>
    )
  }
}
